import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Navbar = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 30px;
  svg {
    width: 116px;
    height: 44px;
  }
`;

export const Content = styled.div`
  width: 100%;
  min-height: calc(100vh - 104px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
